import { lazyRouteComponent } from 'src/lib/routing';
import { INTEGRATION_CALLBACK_PATH } from 'src/utils/integrations';
import { RequireAuth } from 'containers/Auth/RequireAuth';

import type { RouteObject } from 'src/lib/routing';

const IntegrationAuthCallbackContainer = lazyRouteComponent(
  () => import('./IntegrationAuthCallbackContainer'),
  'IntegrationAuthCallbackContainer',
);

export const integrationAuthRoutes: RouteObject[] = [
  {
    path: INTEGRATION_CALLBACK_PATH,
    element: (
      <RequireAuth>
        <IntegrationAuthCallbackContainer />
      </RequireAuth>
    ),
  },
];
